import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { Box, Card, Flex, Text, Title, type BoxProps } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreInquiry } from '@flecto/types'
import { Icon, TextDate } from '@flecto/ui'

import { useStoreDetails } from '../../hooks/useStoreDetails'
import { TextOrderId } from '../TextOrderId/TextOrderId'

export type CardOrderDetailsProps = BoxProps & {
  order?: CoreInquiry
}

export function CardOrderDetails({ order, ...props }: CardOrderDetailsProps) {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-confirmation',
  })
  const store = useStoreDetails()

  if (!order) {
    return
  }

  return (
    <Card {...props}>
      <Title order={5}>{t('card_order_details.title')}</Title>
      <Box mt='md'>
        <Text fw={500}>{t('card_order_details.label_order_id')}</Text>
        <TextOrderId order={order} />
      </Box>
      <Box mt='md'>
        <Text fw={500}>{t('card_order_details.label_dates')}</Text>
        <Flex align='center' gap='sm'>
          <TextDate date={order.start_at} />
          <Icon icon={faArrowRight} color='gray.5' />
          <TextDate date={order.end_at} />
        </Flex>
      </Box>
      <Box mt='md'>
        <Text fw={500}>{t('card_order_details.label_flexible_dates')}</Text>
        <Text>{order.flexible_dates ? 'Yes' : 'No'}</Text>
      </Box>
      <Box mt='md'>
        <Text fw={500}>{t('card_order_details.label_name')}</Text>
        <Text>{order.full_name}</Text>
      </Box>
      <Box mt='md'>
        <Text fw={500}>{t('card_order_details.label_email')}</Text>
        <Text>{order.email}</Text>
      </Box>
      <Box mt='md'>
        <Text fw={500}>{t('card_order_details.label_phone_number')}</Text>
        <Text>
          {order.meta?.phone_number_country_code} {order.phone_number}
        </Text>
      </Box>
      <Box mt='md'>
        <Text fw={500}>
          {t('card_order_details.label_message_to_store', {
            store: store?.name,
          })}
        </Text>
        <Text>{order.renter_message}</Text>
      </Box>
    </Card>
  )
}
